var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7699 0.141972C9.46248 -0.0860283 9.01765 -0.0340283 8.77611 0.255972L3.77882 6.2613L1.38536 3.4633C1.13886 3.1773 0.694026 3.13064 0.389442 3.36197C0.0841507 3.5933 0.0366923 4.0133 0.281067 4.2993L3.23411 7.7513C3.3694 7.90864 3.57198 7.99997 3.78661 7.99997H3.79157C4.0069 7.99864 4.2109 7.90464 4.34407 7.74397L9.89103 1.0773C10.1326 0.787971 10.0787 0.368638 9.7699 0.141972ZM13.3116 0.141972C13.0034 -0.0860283 12.5593 -0.0340283 12.3178 0.255972L7.32048 6.2613L6.89265 5.76197L5.99661 6.83997L6.77577 7.7513C6.91107 7.90864 7.11365 7.99997 7.32827 7.99997H7.33323C7.54856 7.99864 7.75256 7.90464 7.88573 7.74397L13.4327 1.0773C13.6742 0.787971 13.6204 0.368638 13.3116 0.141972ZM5.06919 3.6297L4.17173 4.70703L3.82323 4.2997C3.57815 4.01303 3.62561 3.59303 3.9309 3.3617C4.23619 3.13103 4.68173 3.17703 4.92682 3.4637L5.06919 3.6297Z",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayTick);
export default __webpack_public_path__ + "static/media/gray_tick.f3515802e268edad2856e50afa1c9f15.svg";
export { ForwardRef as ReactComponent };